import TextImageModal from 'components/Modal/OutOfReact/TextImageModal/TextImageModal';
import VideoModal from 'components/Modal/OutOfReact/VideoModal/VideoModal';
import { INonReactModal } from 'interfaces/modal';
import React, { useEffect, useState } from 'react';

const NonReactModal = (): JSX.Element => {
  const [showModal, setShowModal] = useState(true);
  const [modalData, setModalData] = useState<INonReactModal | undefined>();

  useEffect(() => {
    const handleModalEvent = (event: Event) => {
      const eventDetail = (event as CustomEvent).detail;
      const type = eventDetail.type;
      if (type) {
        setModalData({
          type: type,
          id: eventDetail.id,
          videoId: eventDetail.videoId,
          futureContentEnabled: eventDetail.futureContentEnabled,
        });
      } else {
        setModalData(undefined);
      }
      setShowModal(true);
    };
    window.addEventListener('react-modal-open', handleModalEvent);
    return () => {
      window.removeEventListener('react-modal-open', handleModalEvent);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (showModal && modalData) {
    switch (modalData.type) {
      case 'textImage':
        return (
          <TextImageModal
            id={modalData.id ? modalData.id : ''}
            closeFunction={() => setShowModal(false)}
            isOpen={showModal}
            isFutureContent={modalData.futureContentEnabled}
          />
        );
      case 'video':
        return (
          <VideoModal
            videoId={modalData.videoId ? modalData.videoId : ''}
            closeFunction={() => setShowModal(false)}
            isOpen={showModal}
            autoplay
            fullscreen
          />
        );
      default:
        return <></>;
    }
  } else {
    return <></>;
  }
};

export default NonReactModal;
